import { VERSION } from 'version';

export interface VersionContext {
  res: any;
}

export const execute = async (context: any, callback: () => Promise<any>): Promise<void> => {
  try {
    const result = await callback();

    context.res = result;
  } catch (error) {
    console.error(error);
  }
};

export const versionHandler = async (context: any, req: any): Promise<void> => {
  await execute(context, async () => {
    const response = VERSION;
    return { ...response };
  });
};